// Angular
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// Libraries
import { BehaviorSubject, takeUntil } from 'rxjs';

// Models
import { HorizontalItem } from '../../../models/horizontal-item.model';
import { AppCleanup } from '../../../models';

@Injectable()
export class HeaderService extends AppCleanup {
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);

	constructor(private router: Router) {
		super();

		this.router.events.pipe(takeUntil(this.destroy)).subscribe((value) => {
			if (value instanceof NavigationEnd) {
				let url = value.urlAfterRedirects;
				if (!url.includes('/job/') || url == '/job/complete') {
					this.loadMenuWithConfig([]);
				}
			}
		});
	}

	loadMenuWithConfig(horizontalItems: HorizontalItem[]) {
		this.menuList$.next(horizontalItems);
	}
}
